import { render } from "./ClientProlon.vue?vue&type=template&id=71051f2a"
import script from "./ClientProlon.vue?vue&type=script&lang=js"
export * from "./ClientProlon.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__